/**
 * Public origin for owner accept / password-reset links (#455).
 *
 * customDomain if set; localhost -> local owner port; otherwise the CURRENT console origin
 * (every owner can sign in there and it serves /#/owner/accept). Never a `{slug}.pages.dev`
 * guess: that host can belong to someone else.
 */
export function ownerSiteOrigin(opts: {
  /** Kept for call-site compatibility; no longer used to synthesize a host. */
  slug?: string;
  customDomain: string;
  /** Injected for tests; defaults to window.location.hostname when present. */
  hostname?: string;
  /** Injected for tests; defaults to window.location.origin when present. */
  origin?: string;
}): string {
  const domain = opts.customDomain.trim();
  if (domain) {
    return `https://${domain.replace(/^https?:\/\//i, "").replace(/\/$/, "")}`;
  }
  const host =
    opts.hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  if (host === "localhost" || host === "127.0.0.1") {
    return "http://localhost:5174";
  }
  const origin =
    opts.origin ?? (typeof window !== "undefined" ? window.location.origin : "");
  return origin.replace(/\/$/, "");
}
